import I18n from 'I18n';
import { RemoveIcon } from 'foundations-assets';
import { CONTENT_INLINE_MARGIN } from '../constants/styling';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useAnalyticsSuiteNavigation } from '../hooks/useAnalyticsSuiteNavigation';
import { ActionsCollapser } from 'foundations-components/transitional/components/ActionsCollapser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UseCaseFilters = () => {
  const {
    selectedUseCaseId,
    navigateToUseCase,
    clearSelectedUseCase,
    visibleUseCases
  } = useAnalyticsSuiteNavigation();
  if (!visibleUseCases || !Array.isArray(visibleUseCases) || (visibleUseCases === null || visibleUseCases === void 0 ? void 0 : visibleUseCases.length) === 0) {
    return null;
  }
  const handleUseCaseClick = useCaseId => {
    if (selectedUseCaseId === useCaseId) {
      clearSelectedUseCase();
    } else {
      navigateToUseCase(useCaseId);
    }
  };
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: "100%",
    marginBlockEnd: "800",
    paddingInline: CONTENT_INLINE_MARGIN,
    children: /*#__PURE__*/_jsx(ActionsCollapser, {
      inlineSize: "100%",
      dropdownProps: {
        buttonUse: 'transparent',
        buttonSize: 'extra-small'
      },
      children: visibleUseCases.map(useCase => {
        const isSelected = selectedUseCaseId === useCase.id;
        return /*#__PURE__*/_jsxs(Button, {
          use: isSelected ? 'tertiary' : 'tertiary-extra-light',
          size: "extra-small",
          onClick: () => handleUseCaseClick(useCase.id),
          "aria-pressed": isSelected,
          "aria-label": I18n.text(isSelected ? 'smartLibrary.analyticsSuite.useCases.removeFilterLabel' : 'smartLibrary.analyticsSuite.useCases.filterLabel', {
            useCase: I18n.text(useCase.titleKey)
          }),
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: useCase.titleKey
          }), isSelected && /*#__PURE__*/_jsx(RemoveIcon, {})]
        }, useCase.id);
      })
    })
  });
};